import { render } from "./ProgramSummary.vue?vue&type=template&id=78f3723b"
import script from "./ProgramSummary.vue?vue&type=script&lang=js"
export * from "./ProgramSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__